window.$ = window.jQuery = require('jquery');

require('jquery-viewport-checker');
require('simplelightbox');
require('bootstrap');
require('leaflet');
require('slick-carousel');